import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { EInterceptorOptionsHTTPHeaders } from "./EInterceptorOptionsHTTPHeaders"
import { LoadingService } from '../../_services/shared/loading.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loadingService: LoadingService) {
  }

  /**
   * shows loading wheel while requests are in transit, removes requests from array as they complete, when no more requests disable loading wheel
   * @param req - the request to handle
   * @param next - next action in http lifecycle (callback)
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.requests.push(req);
    // this.loadingService.hideAll()
    // return next.handle(req)
    if(req.headers.get(EInterceptorOptionsHTTPHeaders.SuppressLoadingInterceptor)){
      return next.handle(req)
    } else {
      this.loadingService.setLoading(true, req.url)
      return next.handle(req)
      .pipe(
        catchError((err) => {
          this.loadingService.setLoading(false, req.url);
          return throwError(err)
          // return of(err)
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this.loadingService.setLoading(false, req.url);
        }
        return evt;
      }));
    }






    /// OLD
    // if (this.requests.length === 1 && !req.headers.has(EInterceptorOptionsHTTPHeaders.SuppressLoadingInterceptor)) {
    //   this.loadingService.toggle(true);
    // }


    // return Observable.create(observer => {
    //   const subscription = next.handle(req)
    //     .subscribe(
    //       event => {
    //         if (event instanceof HttpResponse) {
    //           this.removeRequest(req);
    //           observer.next(event);
    //         }
    //       },
    //       err => {
    //         this.removeRequest(req);
    //         observer.error(err);
    //       },
    //       () => {
    //         this.removeRequest(req);
    //         observer.complete();
    //       });
    //   // teardown logic in case of cancelled requests
    //   return () => {
    //     this.removeRequest(req);
    //     subscription.unsubscribe();
    //   };
    // });
  }
}
